import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Menu } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetHeader,
  SheetTitle,
  SheetClose,
} from '@/components/ui/sheet'
import { cn } from '@/lib/utils'
import logoFarol from '@/assets/faroledu.jpg'

export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const navLinks = [
    { name: 'Como Funciona', href: '/#como-funciona' },
    { name: 'Para Escolas', href: '/#escolas' },
    { name: 'Para Educadores', href: '/#educadores' },
  ]

  const handleCreateJob = () => {
    navigate('/anunciar-vaga')
  }

  return (
    <nav
      className={cn(
        'fixed top-0 left-0 right-0 z-50 transition-all duration-300 ease-in-out',
        isScrolled
          ? 'bg-white shadow-md py-3 border-b border-gray-100'
          : 'bg-transparent py-5',
      )}
    >
      <div className="container mx-auto px-4 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 z-50">
          <img
            src={logoFarol}
            alt="Farol Edu"
            className="h-10 w-auto object-contain"
          />
          <span
            className={cn(
              'font-bold text-xl tracking-tight hidden sm:block',
              isScrolled ? 'text-brand-navy' : 'text-brand-navy',
            )}
          >
            Farol Edu
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-sm font-medium text-slate-600 hover:text-brand-emerald transition-colors"
            >
              {link.name}
            </a>
          ))}
        </div>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-4">
          <Button
            className="bg-brand-emerald hover:bg-emerald-600 text-white font-semibold shadow-lg hover:shadow-glow transition-all duration-300"
            size="lg"
            onClick={handleCreateJob}
          >
            Criar Vaga
          </Button>
        </div>

        {/* Mobile Menu */}
        <div className="md:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="text-slate-800">
                <Menu className="h-6 w-6" />
                <span className="sr-only">Menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] sm:w-[400px]">
              <SheetHeader className="text-left border-b pb-4 mb-4">
                <SheetTitle>Menu</SheetTitle>
              </SheetHeader>
              <div className="flex flex-col gap-6">
                <div className="flex flex-col gap-4">
                  {navLinks.map((link) => (
                    <SheetClose asChild key={link.name}>
                      <a
                        href={link.href}
                        className="text-lg font-medium text-slate-700 hover:text-brand-emerald"
                      >
                        {link.name}
                      </a>
                    </SheetClose>
                  ))}
                </div>
                <div className="border-t pt-6">
                  <SheetClose asChild>
                    <Button
                      className="w-full bg-brand-emerald hover:bg-emerald-600 text-white font-semibold"
                      size="lg"
                      onClick={handleCreateJob}
                    >
                      Criar Vaga
                    </Button>
                  </SheetClose>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>
  )
}
